const filesRoutes = [
    {
        path: '/admin/files-management',
        name: 'AdminFiles',
        component: () => import(/* webpackChunkName: "admin-files" */ '../views/admin/Files/AdminFiles.vue')
    },
    {
        path: '/admin/view-folder/:id/:name',
        name: 'AdminViewFolder',
        component: () => import(/* webpackChunkName: "admin-view-folder" */ '../views/admin/Files/AdminViewFolder.vue')
    }
]
export default filesRoutes
